// src/api/signals.js
// API utility for signal engine and live TA indicators

export async function getIndicators(symbol, period = "3mo", interval = "1d") {
  const params = new URLSearchParams({ period, interval });
  const response = await fetch(`/signals/indicators/${encodeURIComponent(symbol.toUpperCase())}?${params}`);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.detail || `Failed to fetch indicators for ${symbol}`);
  }
  return response.json();
}

export async function evaluateSignal(payload) {
  const response = await fetch("/signals/evaluate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error("Signal evaluation failed");
  return response.json();
}

export async function getRegimeFloors() {
  const response = await fetch("/signals/regime/floors");
  if (!response.ok) throw new Error("Failed to fetch regime floors");
  return response.json();
}
